<template>
  <div v-loading="loading" style="padding: 0 2% 0 2%">
    <h2>身份绑定</h2>
    <div style="min-height: 224px">
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        :size="formSize"
        status-icon
        label-position="top"
        hide-required-asterisk="true"
      >
        <el-form-item prop="IPAddress" :show-message="false">
          <template #label>
            <h3>
              <span class="OrangeColor">*</span> 请在学校网络
              <span class="OrangeColor">IP</span> 范围内进行绑定
            </h3>
          </template>
          <el-select
            v-model="ruleForm.IPAddress"
            filterable
            size="large"
            style="width: 80%; padding-left: 11%"
            placeholder="请选择"
          >
            <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0">
          <el-row justify="space-around" style="margin-top: 50px; width: 100%">
            <el-col :span="9">
              <el-button
                size="large"
                style="width: 100%"
                type="info"
                @click="cancelView"
              >
                取消
              </el-button>
            </el-col>
            <el-col :span="9">
              <el-button
                size="large"
                style="width: 100%"
                type="primary"
                background-color="#E65833"
                @click="submitForm(ruleFormRef)"
              >
                绑定
              </el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, shallowRef} from "vue";
import {binderAgency, getAgencySelect} from "@/request/api/index.js";
import {ElMessage} from "element-plus";
import useLogin from "@/stores/login";
import IdentityBinding from "@/views/login/IdentityBinding.vue";
const formSize = ref("default");
const ruleFormRef = ref();
const ruleForm = reactive({
  IPAddress: "",
});
const loginStore = useLogin();
const loading = ref(false);
//取消
const cancelView = () => {
  loginStore.showVisible = false;
}

onMounted(() => {
  //获取机构下拉框
  getAgencyList();
})
const  getAgencyList = () => {
  loading.value = true;
  getAgencySelect().then(res=>{
    loading.value = false;
    if(res.status == 10000){
      selectOptions.value = res.data;
    }
  })
}

const selectOptions = ref([
  {
    value: 1,
    label: "xxx.xxx.xxx.xxx",
  },
  {
    value: 2,
    label: "xxx.xxx.xxx.xxx",
  },
]);
const rules = reactive({
  IPAddress: [{ required: true, message: "请选择IP", trigger: "change" }],
});
const submitForm = async (formEl) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      binderAgency(ruleForm.IPAddress).then(res=>{
        if(res.status == 10000){
          ElMessage.success("绑定成功");
          loginStore.showVisible = false;
          loginStore.agencyId = res.data.agencyId;
          loginStore.code = res.data.agencyCode;
        }else {
          ElMessage.error(res.msg);
        }
      })

    } else {
      console.log("error submit!", fields);
    }
  });
};
</script>

<style lang="scss" scoped>
@import "@/styles/elementButton.scss";
@import "@/styles/common.scss";
@import "@/styles/variables.scss";
h2 {
  margin: 0 0 30px 0;
  text-align: center;
  color: #000;
}
h3 {
  margin: 0 0 50px 0;
  text-align: center;
  color: #000;
}
</style>
